import http from '@/http-common'
import InputGroupForm from "@/components/InputGroupForm";
import SelectTab from '../../components/TabSpr.vue'

export default {
    components: {InputGroupForm, SelectTab},
    name: "MoveSummaEkp",
    data() {
        return {
            selectedOrg: null,
            selectedKindFrom: null,
            selectedKindTo: null,
            selectedItem: {},
            orgList: [],
            kindList: [],
            summaMove: 0,
            selectedYear: (new Date()).getFullYear(),
            yearList: [],
            modalSelectOpened: false,
            items: [],
            captionTable: 'Мероприятия',
            columns: [
                {key: 'dateEvent', label: 'Код'},
                {key: 'nameEvent', label: 'Наименование', sortable: true, sorted: true},
                {key: 'summaEkp', label: 'Сумма', sortable: false, sorted: false},
                {key: 'summaBalance', label: 'Остаток', sortable: false, sorted: false},
                {key: 'held', label: 'Проведено', sortable: false, sorted: false}
            ],
            captionSpr: {
                name: '',
                nameR: ''
            },
            selectedEventFrom: {id: 0, nameEvent: '', summaEkp: 0, summaBalance: 0},
            selectedEventTo: {id: 0, nameEvent: '', summaEkp: 0, summaBalance: 0},
            eventFromTo: 0,
            validForm: {
                summa: true,
                org: true,
                sportKind: true,
                eventFrom: true,
                eventTo: true,
                file: true,
                form: true
            },
            dataResult: null,
            dismissSecs: 5,
            dismissCountDown: 0,
            isTwoSportEkp: true,
            variantMess: 'success',
            textMsg: 'Успешно перенесено',
            docFilesOpt: [],
            selectedFileId: 0,
            ekpTypeList: [],
            selectedEkpType: 0
        }
    },
    created() {
        this.loadOrgs()
        this.loadKind()
        this.loadYears()
        this.loadDocFiles()
        this.loadEkpTypes()
    },
    methods: {
        loadYears() {
            this.yearList = []
            let vm = this
            const yearNow = (new Date()).getFullYear();
            for (let i = yearNow - 2; i <= yearNow + 1; i++) {
                let yearObj = {value: i, text: i.toString()}
                vm.yearList.push(yearObj);
            }
        },
        loadKind() {
            let vm = this;
            http.get('/option/sportkind')
                .then((response) => {
                    vm.kindList = response.data;
                    vm.selectedKindFrom = vm.kindList[0].value;
                    vm.selectedKindTo = vm.kindList[0].value;
                })
                .catch((error) => console.log(error.response.data));
        },
        loadOrgs() {
            let vm = this;
            http.get('/org/list')
                .then((response) => {
                    vm.orgList = response.data;
                    vm.orgList.forEach(function (x) {
                        x.value = x.id;
                        x.text = x.shortName;
                    })
                    vm.selectedOrg = vm.orgList[0].id;
                })
                .catch((error) => console.log(error.message));
        },
        selectEvent() {
            this.$refs.eventTab.editSpr();
        },
        selectEventFrom() {
            this.eventFromTo = 0
            this.modalSelectOpened = true
            this.loadEvent()
        },
        selectEventTo() {
            this.eventFromTo = 1
            this.modalSelectOpened = true
            this.loadEvent()
        },
        loadEvent() {
            let vm = this;
            let planYear = this.selectedYear;
            let dat1 = planYear.toString() + "-01-01";
            let dat2 = planYear.toString() + "-12-31";
            let filter = '';
            if (!vm.isTwoSportEkp)
                vm.selectedKindTo = vm.selectedKindFrom

            if (vm.eventFromTo === 0)
                filter = 'dat1=' + dat1 + '&dat2=' + dat2 + '&sportkind_id=' + vm.selectedKindFrom + '&org_id=' + vm.selectedOrg + '&ekp_type_id=' + vm.selectedEkpType;
            else
                filter = 'dat1=' + dat1 + '&dat2=' + dat2 + '&sportkind_id=' + vm.selectedKindTo + '&org_id=' + vm.selectedOrg + '&ekp_type_id=' + vm.selectedEkpType;
            http.get('/ekp/listMove?' + filter)
                .then((response) => {
                    vm.items = response.data;
                })
                .catch((error) => console.log(error.response.data));
        },
        selectItemEvent() {
            if (this.eventFromTo === 0) {
                for (let key in this.selectedItem) {
                    this.selectedEventFrom[key] = this.selectedItem[key];
                }
                console.log('event1: ' + this.selectedEventFrom.nameEvent)
            } else {
                for (let key in this.selectedItem) {
                    this.selectedEventTo[key] = this.selectedItem[key];
                }
                console.log('event2: ' + this.selectedEventTo.nameEvent)
            }
            this.modalSelectOpened = false
        },
        moveEvent() {
            this.checkForm();
            let vm = this;
            let data = {
                ekpFromId: this.selectedEventFrom.id,
                ekpToId: this.selectedEventTo.id,
                summa: this.summaMove,
                docChangeId: this.selectedFileId
            }
            if (this.validForm.form) {
                http.post("/ekp/moveSum", data)
                    .then((res) => {
                        let dataResult = res.data;
                        if (dataResult === "success") {
                            vm.dismissCountDown = vm.dismissSecs
                            vm.textMsg = 'Успешно перенесено'
                            vm.variantMess = 'success'
                        }
                    })
                    .catch(function (error) {
                        vm.dismissCountDown = vm.dismissSecs
                        vm.variantMess = 'warning'
                        if (error.response.status === 403)
                            vm.textMsg = 'Нет прав!!!'
                        else
                            vm.textMsg = error.response.data
                    })
            }
        },
        checkForm() {
            let vm = this;
            for (let key in vm.validForm) {
                vm.validForm[key] = true;
            }
            if (vm.selectedOrg === null || vm.selectedOrg <= 0) {
                vm.validForm.org = false
                vm.validForm.form = false
            }
            if (vm.selectedKindFrom === null || vm.selectedKindFrom <= 0) {
                vm.validForm.sportKind = false
                vm.validForm.form = false
            }
            if (vm.selectedKindTo === null || vm.selectedKindTo <= 0) {
                vm.validForm.sportKind = false
                vm.validForm.form = false
            }
            if (vm.selectedEventFrom === null || vm.selectedEventFrom.id <= 0) {
                vm.validForm.eventFrom = false
                vm.validForm.form = false
            }
            if (vm.selectedEventTo === null || vm.selectedEventTo.id <= 0) {
                vm.validForm.eventTo = false
                vm.validForm.form = false
            }
            if (vm.summaMove === null || vm.summaMove <= 0) {
                vm.validForm.summa = false
                vm.validForm.form = false
            }
            if (vm.selectedFileId === null || vm.selectedFileId <= 0) {
                vm.validForm.file = false
                vm.validForm.form = false
            }
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown
        },
        showAlert() {

        },
        getNameEvent(rec) {
            if (rec !== null)
                return rec.nameEvent +'\nСумма: ' + rec.summaEkp
            else
                return ''
        },
        loadDocFiles() {
            let vm = this;
            http.get('/document/list')
                .then((response) => {
                    vm.docFiles = response.data;
                    vm.docFiles.forEach(function (x) {
                        let opt = {value: x.id, text: x.nameDoc}
                        vm.docFilesOpt.push(opt)
                    })
                })
                .catch((error) => console.log(error.response.data));
        },
        loadEkpTypes() {
            let vm = this;
            http.get('/option/ekpType')
                .then((response) => {
                    vm.ekpTypeList = response.data;
                    vm.selectedEkpType = vm.ekpTypeList[0].value;
                })
                .catch((error) => console.log(error.message));
        },
    }
}
